module.exports = __webpack_public_path__ + "img/moreImg.9a4e009a.png";